<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7489 11.0854L11.8786 11.9557C10.4861 13.3481 8.31042 13.3481 7.00499 11.9557L2.04435 7.08204C0.651885 5.68958 0.651885 3.51386 2.04435 2.1214L2.91463 1.25112C3.26275 0.903001 3.87195 0.903001 4.22006 1.33814L5.5255 2.99169C5.78658 3.33981 5.78658 3.86198 5.43847 4.12307L4.30709 5.34147L8.65853 9.69291L9.87693 8.4745C10.225 8.12639 10.6602 8.12639 11.0083 8.38747L12.6619 9.69291C13.097 10.128 13.097 10.7373 12.7489 11.0854Z"
      stroke="white"
      stroke-width="1.5"
    />
  </svg>
</template>
